const Footer = () => {
  const areas = [
    'Direito Civil',
    'Direito Imobiliário',
    'Direito do Consumidor',
    'Direito de Família',
    'Direito das Sucessões',
    'Direito Trabalhista',
    'Direito Empresarial',
    'Direito de Energia',
  ];

  const links = [
    { label: 'Início', href: '#inicio' },
    { label: 'Escritório', href: '#escritorio' },
    { label: 'Áreas de Atuação', href: '#areas' },
    { label: 'Como Atuamos', href: '#como-atuamos' },
    { label: 'Contato', href: '#contato' },
  ];

  return (
    <footer className="bg-white text-[#1B2A4A]">
      {/* Main Footer */}
      <div className="border-t border-[#1B2A4A]/10">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-14">
            {/* Brand */}
            <div className="lg:col-span-1">
              <img
                src="https://static.readdy.ai/image/2751d92eb47f633f00285d5acf7c03f9/1df16a0421aff30730be1a43f64118c6.png"
                alt="Hélio de Oliveira & Santos Oliveira Advogados"
                className="h-[72px] w-auto object-contain mb-6"
              />
              <p className="text-[#1B2A4A]/60 text-sm leading-relaxed mb-6">
                Advocacia estratégica com foco em proteção patrimonial, prevenção de riscos e
                decisões seguras.
              </p>
              {/* Social */}
              <div className="flex items-center gap-3">
                {[
                  { icon: 'ri-linkedin-fill', href: 'https://www.linkedin.com/company/hosoadv/' },
                  { icon: 'ri-instagram-line', href: 'https://www.instagram.com/hosoadv' },
                  { icon: 'ri-facebook-fill', href: 'https://www.facebook.com/hosoadv' },
                  { icon: 'ri-whatsapp-line', href: 'https://wa.me/5521999887645' },
                ].map((s) => (
                  <a
                    key={s.icon}
                    href={s.href}
                    rel="noopener noreferrer nofollow"
                    target="_blank"
                    className="w-9 h-9 flex items-center justify-center border border-[#1B2A4A]/20 text-[#1B2A4A]/50 hover:border-[#C8A96A] hover:text-[#C8A96A] transition-all duration-300 cursor-pointer"
                  >
                    <i className={`${s.icon} text-sm`}></i>
                  </a>
                ))}
              </div>
            </div>

            {/* Navigation */}
            <div>
              <h4 id="footer-nav">
                <a href="#inicio" className="text-[#1B2A4A] text-xs font-semibold tracking-[0.3em] uppercase mb-5 block">
                  Navegação
                </a>
              </h4>
              <ul className="space-y-3">
                {links.map((link) => (
                  <li key={link.href}>
                    <a
                      href={link.href}
                      className="text-[#1B2A4A]/60 text-sm hover:text-[#C8A96A] transition-colors duration-200 cursor-pointer flex items-center gap-2"
                    >
                      <i className="ri-arrow-right-s-line text-[#C8A96A] text-xs"></i>
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Areas */}
            <div>
              <h4 id="footer-areas">
                <a href="#areas" className="text-[#1B2A4A] text-xs font-semibold tracking-[0.3em] uppercase mb-5 block">
                  Áreas de Atuação
                </a>
              </h4>
              <ul className="space-y-3">
                {areas.map((area) => (
                  <li key={area}>
                    <a
                      href="#areas"
                      className="text-[#1B2A4A]/60 text-sm hover:text-[#C8A96A] transition-colors duration-200 cursor-pointer flex items-center gap-2"
                    >
                      <i className="ri-arrow-right-s-line text-[#C8A96A] text-xs"></i>
                      {area}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 id="footer-contact">
                <a href="#contato" className="text-[#1B2A4A] text-xs font-semibold tracking-[0.3em] uppercase mb-5 block">
                  Contato
                </a>
              </h4>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-map-pin-2-line text-[#C8A96A] text-sm"></i>
                  </div>
                  <span className="text-[#1B2A4A]/60 text-sm leading-relaxed">
                    Av. Rio Branco n.º 156, 26º andar<br />
                    Centro – Rio de Janeiro – RJ
                  </span>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-[#C8A96A] text-sm"></i>
                  </div>
                  <a
                    href="mailto:contato@hosoadv.com.br"
                    className="text-[#1B2A4A]/60 text-sm hover:text-[#C8A96A] transition-colors cursor-pointer"
                  >
                    contato@hosoadv.com.br
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-whatsapp-line text-[#C8A96A] text-sm"></i>
                  </div>
                  <div className="flex flex-col gap-1">
                    <a
                      href="https://wa.me/5521999887645"
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="text-[#1B2A4A]/60 text-sm hover:text-[#C8A96A] transition-colors cursor-pointer"
                    >
                      (21) 99988-7645
                    </a>
                    <a
                      href="https://wa.me/5521999751955"
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="text-[#1B2A4A]/60 text-sm hover:text-[#C8A96A] transition-colors cursor-pointer"
                    >
                      (21) 99975-1955 – Dr. Helio
                    </a>
                    <a
                      href="https://wa.me/5521980923713"
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="text-[#1B2A4A]/60 text-sm hover:text-[#C8A96A] transition-colors cursor-pointer"
                    >
                      (21) 98092-3713 – Dr. Filipe Santos Oliveira
                    </a>
                    <a
                      href="https://wa.me/5521970089448"
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      className="text-[#1B2A4A]/60 text-sm hover:text-[#C8A96A] transition-colors cursor-pointer"
                    >
                      (21) 9.7008.9448 – Dr. Bruno Santos Oliveira
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-[#1B2A4A]/10">
        <div className="max-w-7xl mx-auto px-6 py-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#1B2A4A]/40 text-xs">
            &copy; {new Date().getFullYear()} Hélio de Oliveira &amp; Santos Oliveira Advogados.
            Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-6">
            <a
              href="https://startdigital1.com.br"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="text-[#1B2A4A]/40 text-xs hover:text-[#C8A96A] transition-colors cursor-pointer"
            >
              Desenvolvido por Start Digital
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
